import { Trans } from '@lingui/react/macro'
import { Card, Divider } from '@tecsinapse/cortex-react'
import React from 'react'
import { FaRegCalendarAlt, FaRegFileAlt } from 'react-icons/fa'
import { GoFileDirectory } from 'react-icons/go'
import { MdOutlineMail } from 'react-icons/md'
import { i18n } from '@/i18n'
import { itemFooter } from '@/core/styles/item-footer'

export type ItemBibliotecaHomeCardType = {
  dataCriacao: Date
  nome: string
  proprietario: {
    email: string
  }
  pastaPai: {
    nome: string
  }
}

interface IItemBibliotecaHomeCardCortex {
  itemBiblioteca: ItemBibliotecaHomeCardType
}

const { container, icon, span } = itemFooter()

export const ItemBibliotecaHomeCard = ({
  itemBiblioteca
}: IItemBibliotecaHomeCardCortex) => {
  const {
    dataCriacao,
    nome,
    pastaPai: { nome: nomePastaPai },
    proprietario: { email }
  } = itemBiblioteca
  return (
    <Card className={'mb-deca border px-0 py-0'}>
      <div className='flex justify-between items-center p-deca'>
        <div className='flex flex-row gap-x-mili mr-kilo truncate items-center'>
          <FaRegFileAlt className={icon()} />
          <p className='font-bold text-h3 min-auto truncate'>{nome}</p>
        </div>
      </div>
      <Divider />
      <div className='px-deca pb-deca pt-mili flex flex-col lg:flex-row items-start lg:itens:center lg:space-x-kilo'>
        <div className={container()}>
          <MdOutlineMail className={icon({ className: 'mt-[2px]' })} />
          <p className='font-bold'>{email}</p>
        </div>
        <div className={container()}>
          <FaRegCalendarAlt className={icon()} />
          <p className={'flex flex-nowrap space-x-micro'}>
            <span className={span()}>
              <Trans>Publicação:</Trans>
            </span>
            <p>{i18n.date(dataCriacao, { dateStyle: 'short' })}</p>
          </p>
        </div>
        <div className={container({ className: 'min-w-0' })}>
          <GoFileDirectory className={icon()} />
          <p className={'truncate'}>{nomePastaPai}</p>
        </div>
      </div>
    </Card>
  )
}
